<style>
  #companyLogoImg {
    height: 50px;
  }

  .cat__top-bar__logo a {
    display: block;
  }

  .cat__top-bar__logo {
    width: 15.28rem;
    margin-right: 0;
    padding: 1rem 27px 1rem 0;
  }

  .top-bar__flfl {
    width: 100%;
    display: flex;
    padding: 1rem 1.28rem 1rem 0;
  }

  .top-bar__flfl .btn.btn-link {
    display: block;
    padding-left: 0;
  }

  .top-bar__flfl .dropdown-menu img {
    border-left: 0;
    padding-left: 10px;
  }

  .top-bar__flfl img {
    max-height: 1.9rem;
    border-left: 1px solid #f1f1f1;
    padding-left: 27px;
  }

  .cat__top-bar__right {
    padding-right: 10px;
  }

  .cat__top-bar__right .fa-bars {
    cursor: pointer;
    color: #37669e;
    font-size: 20px;
    vertical-align: middle;
    margin-right: 10px;
  }

  .cat__top-bar__right .fa-bars.openbtn {
    font-size: 22px;
    cursor: pointer;
    color: #37669e;
  }

  @media screen and (max-width: 991px) {
    .lastLoginTime2 {
      display: none;
    }

    #companyLogoImg {
      height: 46px;
      width: 52px;
    }

    .cat__top-bar__right .cat__top-bar__item {
      margin-left: 0;
      cursor: pointer;
      padding: 5px;
    }

    .cat__top-bar__right {
      padding-right: 0;
    }
  }

  @media screen and (max-width: 767px) {
    .cat__top-bar__logo {
      padding-right: 55px;
    }

    .top-bar__flfl img {
      padding-left: 55px;
    }
  }

  @media screen and (max-width: 669px) {
    .cat__top-bar {
      height: auto !important;
    }
  }

  .CompanyDropDown {
    width: 24.71rem;
    margin: -0.5rem 0;
    background: #ffffff;
  }

  /* Modern Profile Dropdown Styling */
  .cat__top-bar__avatar-dropdown .dropdown-menu {
    min-width: 220px;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid #e2e8f0 !important;
    padding: 8px 0;
    margin-top: 10px;
    background: #fff;
    animation: slideDown 0.2s ease;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .cat__top-bar__avatar-dropdown .dropdown-item {
    padding: 12px 20px;
    font-size: 14px;
    color: #2c3e50;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 12px;
    border: none;
    background: transparent;
  }

  .cat__top-bar__avatar-dropdown .dropdown-item:first-child {
    font-weight: 600;
    color: #1e458b;
    font-size: 15px;
    padding: 14px 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #f1f5f9 100%);
    border-bottom: 2px solid #e2e8f0;
    margin-bottom: 4px;
    cursor: default;
  }

  .cat__top-bar__avatar-dropdown .dropdown-item:first-child:hover {
    background: linear-gradient(135deg, #f8f9fa 0%, #f1f5f9 100%);
    color: #1e458b;
  }

  .cat__top-bar__avatar-dropdown .dropdown-item:not(:first-child) {
    cursor: pointer;
  }

  .cat__top-bar__avatar-dropdown .dropdown-item:not(:first-child):hover {
    background: linear-gradient(135deg, #1e458b 0%, #153a6b 100%);
    color: #fff;
    transform: translateX(4px);
  }

  .cat__top-bar__avatar-dropdown .dropdown-item i {
    font-size: 16px;
    width: 20px;
    text-align: center;
    color: inherit;
  }

  .cat__top-bar__avatar-dropdown .dropdown-divider {
    margin: 6px 0;
    border-top: 1px solid #e2e8f0;
    opacity: 1;
  }

  .cat__top-bar__avatar-dropdown .dropdown-item:last-child {
    color: #e74c3c;
  }

  .cat__top-bar__avatar-dropdown .dropdown-item:last-child:hover {
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
    color: #fff;
  }

  .cat__top-bar__avatar-dropdown .dropdown-item:last-child i {
    color: inherit;
  }

  .overflow-auto {
    overflow-y: auto;
    overflow-x: hidden;

  }

  .h-85vh {
    height: 85vh;

  }

  /* Promo banner styles */
  .promo-wrap {
    max-width: 640px;
    position: relative;
  }
  .promo-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0px 5px;
    border-radius: 10px;
    background: linear-gradient(90deg, #f8fbff 0%, #eef9f6 100%);
    border: 1px solid #e6eef8;
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
  }
  .promo-icon {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e6f0fb;
    flex: 0 0 28px;
  }
  .promo-copy { display: flex; flex-direction: column; text-align: left; }
  .promo-head { font-size: 12px; font-weight: 700; color: #0b4971; }
  .promo-body { font-size: 12px; color: #2b2b2b; }
  .promo-cta { margin-left: 12px; flex: 0 0 auto; }
  .promo-cta a {
    font-size: 12px; font-weight: 700; color: #0f62fe; text-decoration: none;
    padding: 6px 10px; border-radius: 6px; border: 1px solid #cfe0ff; background: #ffffff;
    display: inline-block;
  }
  .promo-close {
    margin-left: 6px; border: none; background: transparent; font-size: 16px;
    color: #65708a; cursor: pointer; line-height: 1;
    margin-top: 0;
  }

  /* Responsive adjustments */
  @media screen and (max-width: 991px) {
    .promo-wrap { max-width: 100%; }
    .promo-banner { gap: 8px; padding: 6px 10px; }
    .promo-head, .promo-body, .promo-cta a { font-size: 11px; }
  }
  @media screen and (max-width: 575px) {
    .promo-banner { flex-wrap: wrap; align-items: flex-start; }
    .promo-icon { display: none; }
    .promo-cta { margin-left: 0; margin-top: 6px; }
    .promo-close { margin-left: 0; }
  }
</style>

<div class="modal fade" id="messagePopUpforDeactivateCompany" tabindex="-1" role="dialog" aria-labelledby=""
  aria-hidden="true" style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div id="alertTitles" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
        Title!
      </div>
      <div class="modal-body" style="padding: 10px 15px;">
        <div id="alertMessages" style="font-size: 16px;">
          Message..
        </div>
      </div>
    </div>
  </div>
</div>

<div class="cat__top-bar">
  <!-- left aligned items -->
  <div class="cat__top-bar__left">
    <div class="cat__top-bar__logo">
      <a href="/#/structure/(structure-outlet:dashboards/director-view)">
        <img src="../../../assets/modules/dummy-assets/common/img/GovEVA.png" class="hide-xs" alt="DigiCompany" />
        <img src="../assets/images/logo-mob.svg" class="logo-mob" alt="DigiCompany" />
      </a>
    </div>

    <div class="cat__top-bar__item">
      <i class="fa fa-bars openbtn " style="font-size: 20px;" aria-hidden="true" (click)="toggleNav()" (keydown.enter)="toggleNav()" (keydown.space)="toggleNav(); $event.preventDefault()" tabindex="0" role="button"></i>
    </div>

    <div class="top-bar__flfl">



      <span *ngIf="!rocketBaseURL">
        <span class="company-logo-label" *ngIf="companyLogo ">
          <img id="companyLogoImg" [src]="companyLogo" alt="Logo" style="height: 50px;">
        </span>
        <span class="company-logo-label" *ngIf="!companyLogo">
          <img src="assets/images/company-icon.svg" alt="Logo" />
        </span>
      </span>

      <span *ngIf="rocketBaseURL">
        <span class="company-logo-label" *ngIf="companyLogo ">
          <a [href]="rocketBaseURL" target="_blank">
            <img id="companyLogoImg" [src]="companyLogo" alt="Logo" style="height: 50px;">
          </a>
        </span>
        <span class="company-logo-label" *ngIf="!companyLogo">
          <a [href]="rocketBaseURL" target="_blank">
            <img src="assets/images/company-icon.svg" alt="Logo" />
          </a>
        </span>
      </span>
      <div style="margin-left: 0px;" (click)="toggleCompanySelectTopBarDropdown()">
        <div class="dropdown"> <a href="javascript: void(0);" class="dropdown-toggle" data-toggle="dropdown"
            aria-expanded="false"> <span class="company-name-label">{{companyName}}</span>
          </a>
          <ul class="dropdown-menu " aria-labelledby="" role="menu" id="companySelectTopBarDropdown">
            <div class="CompanyDropDown w-auto overflow-auto h-15vh">
              <div *ngFor="let company of associatedCompanyList;let indexCount=index">
                <div class="cat__top-bar__activity__item" style="cursor: pointer;">
                  <div class="row">
                    <div class="cat__top-bar__activity__inner col-sm-10" (click)="demo(company)">
                      <div class="cat__top-bar__activity__descr " style="font-size: small;"> {{company.CompanyName}}
                      </div>
                    </div>
                    <div class="col-sm-1 d-flex justify-content-center" *ngIf="isSuperAdmin">
                      <i class="fa fa-edit closebtn px-1" style="color: green;" (click)="openEditModal(company)" (keydown.enter)="openEditModal(company)" (keydown.space)="openEditModal(company); $event.preventDefault()" tabindex="0" role="button"
                        title="Edit Company"></i>&nbsp;
                      <i class="fa fa-times closebtn " style="color: red;" (click)="deleteCompany(company)" (keydown.enter)="deleteCompany(company)" (keydown.space)="deleteCompany(company); $event.preventDefault()" tabindex="0" role="button"
                        title="Delete Company"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- right aligned items -->
  <div class="cat__top-bar__right d-flex justify-content-end">
    <div class="cat__top-bar__item promo-wrap" *ngIf="showPromoBanner">
      <div class="promo-banner">
        <div class="promo-icon">
          <img src="../assets/images/megaphone.svg" onerror="this.style.display='none'" alt="" style="width: 16px; height: 16px;" />
          <span style="font-size: 16px; line-height: 1;">📣</span>
        </div>
        <div class="promo-copy">
          <span class="promo-head">Did you know?</span>
          <span class="promo-body">{{ promoBannerMessage }}</span>
        </div>
        <div class="promo-cta">
          <a href="https://digicompany.in/" target="_blank" rel="noopener">Learn more</a>
        </div>
        <button type="button" class="promo-close" (click)="dismissPromoBanner()" aria-label="Close" title="Dismiss">✕</button>
      </div>
    </div>
    <!-- <div class="cat__top-bar__item">
      <i class="fa fa-bars openbtn" aria-hidden="true" (click)="toggleNav()"></i>
    </div> -->

    <ng-template #content let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Messages</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div style="padding: 0px" class="modal-body chat-modal">
        <app-webx-chat></app-webx-chat>
      </div>
    </ng-template>

    <div class="cat__top-bar__item" *ngIf="chat && userType != 'GuestSuperAdmin'"
      [appHasPermission]="{ Url: 'chat', method: 'get', menu: 'Dashboard' }">
      <div class="dropdown">
        <a href="javascript: void(0);" class="dropdown-notification-toggle" (click)="openChatModel(content)"
          data-toggle="dropdown" aria-expanded="false" style="font-size: 24px;">
          <img src="../assets/images/top-comment-icon.png" alt="Comment" />
        </a>
      </div>
    </div>

    <!-- Chatbot FAB (hidden on dashboard alpha; embedded widget used there instead) -->
    <div class="cat__top-bar__item header-chatbot-wrapper" *ngIf="showHeaderChatbotFab">
      <app-chatbot-fab></app-chatbot-fab>
    </div>

    <div class="cat__top-bar__item">
      <div class="dropdown">
        <a href="javascript: void(0);" class="dropdown-notification-toggle" data-toggle="dropdown" aria-expanded="false"
          (click)="viewAllNotification()" style="font-size: 24px;">
          <img src="../assets/images/top-notification-icon.png" alt="notification" />
          <span class="notification_count"
            *ngIf="notificationData!=null && notificationData.unreadNotificationCount > 0">{{notificationData.unreadNotificationCount}}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-right notificationParent" aria-labelledby="" role="menu">
          <div class="cat__top-bar__activity notificationList"
            *ngIf="notificationData!=null && notificationData.unreadNotificationCount > 0">
            <div *ngFor="let notification of notificationData.unreadNotificationList;let indexCount=index">
              <div id={{notification._id}} class="cat__top-bar__activity__item" style="cursor: pointer;"
                (click)="viewNotification(notification._id)" *ngIf="indexCount < 3">
                <div class="cat__top-bar__activity__inner">
                  <div class="cat__top-bar__activity__title">
                    <span class="pull-right">{{notification.CreatedDate | date: 'dd/MM/yyyy'}}</span>
                  </div>
                  <div class="cat__top-bar__activity__descr" style="clear: both;"
                    [innerHTML]="notification.Description | safeHtml">
                  </div>
                </div>
              </div>
            </div>
            <div class="cat__top-bar__notification__view-all">
              <a (click)="viewAllNotification()" href="javascript: void(0);">View All</a>
            </div>
          </div>

          <div class="cat__top-bar__activity" *ngIf="
              notificationData == null ||
              notificationData.unreadNotificationCount <= 0
            ">
            <div class="cat__top-bar__activity__item" style="text-align: center; color: #919191; padding: 15px 0">
              All caught up!
            </div>
            <div class="cat__top-bar__notification__view-all">
              <a (click)="viewAllNotification()" href="javascript: void(0);">View All</a>
            </div>
          </div>
        </ul>
      </div>
    </div>

    <div class="cat__top-bar__item">
      <div id="TopBarProfileDropdown" (click)="toggleTopBarProfileDropdown()"
        class="dropdown cat__top-bar__avatar-dropdown">
        <!-- <a href="javascript: void(0);" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false"> -->
        <a href="javascript: void(0);" class="dropdown-toggle">
          <span class="cat__top-bar__avatar" href="javascript:void(0);">
            <img id="userProfilePic" src="../assets/images/top-user-icon.png" alt="ProfilePic" />
          </span>
        </a>
        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="" role="menu">
          <a class="dropdown-item">{{companyName}}</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)" (click)="openEditProfilePopUp();">
            <i class="dropdown-icon icmn-user"></i> Profile</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)" (click)="navigateToChangePasswordScreen();">
            <i class="dropdown-icon fa fa-key"></i> Change Password</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)" (click)="navigateToEditDashboardLayout();">
            <i class="dropdown-icon fa fa-th-large"></i> Edit Dashboard Layout</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)" (click)="logOut()">
            <i class="dropdown-icon icmn-exit"></i> Logout</a>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
  style="top: 50px">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px"></div>
      <div class="modal-body" style="padding: 10px 15px">
        <div id="alertMessage" style="font-size: 16px"></div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editPopup" tabindex="-1" role="dialog" aria-labelledby="editCompanyModalLabel"
  aria-hidden="true" #editPopupModal>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px">
        Edit Company Name
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 10px 15px">
        <!-- Your edit form goes here -->

        <label>
          Company Name
        </label>
        <input type="text" class="form-control" [(ngModel)]="selectedCompanyForediting" />
      </div>
      <div class="modal-footer" style="padding: 10px 15px">
        <!-- Your edit form goes here -->

        <button class="btn btn-primary m-0 mx-1" (click)="editCompanyName()">
          Save
        </button>
        <button class="btn btn-danger m-0 mx-1 " (click)="hideEditModal()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
